import Modal from '../../../../core/components/core/Util/Modal/CustomModal';

function ResyncSaleRevenues({ show, onClose, onConfirm }) {
    return (
        <Modal
            show={show}
            handleShow={() => { }}
            handleClose={onClose}
            handleCancel={onClose}
            handleConfirm={onConfirm}
            title="Sincronizar Receitas"
            content={
                <p>
                    Tem certeza que deseja <strong>sincronizar as receitas</strong> desta venda?
                    Isso irá recriar as parcelas com base nas configurações de pagamento atuais.
                </p>
            }
            showButtons={true}
            showHeader={true}
            confirmButtonText="Sincronizar"
            cancelButtonText="Não"
        />
    );
}

export default ResyncSaleRevenues;
